
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import InternalLineItemForm from '@/components/internal/InternalLineItemForm';

const CreateInternalLineItemPage = () => {
  const navigate = useNavigate();
  
  return (
    <div>
      <div className="mb-6 flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate('/cost-center/internal-line-items')}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold">Add New Line Item</h1>
          <p className="text-muted-foreground">
            Create a new internal line item
          </p>
        </div>
      </div>

      <InternalLineItemForm />
    </div>
  );
};

export default CreateInternalLineItemPage;
